import React, {Component} from 'react'
import { Route, withRouter } from 'react-router-dom'
import Page from '../tags/SecondaryPage/Page'
import Article from '../tags/SecondaryPage/Article'
import { getProperty } from '../../helpers/properties';
import {getConfiguration} from "../../helpers/configuration";

const SecondaryPage = () => (
  <div>
    <div className="page">

      <div className="secondary-page__container secondary-page__container--narrow">
        <Route path={getConfiguration('baseUrl') + '/:pageSlug'} exact component={Page}/>
        <Route path={getConfiguration('baseUrl') + '/:pageSlug/:articleId'} component={Article}/>
      </div>

    </div>
  </div>
)

export default withRouter(SecondaryPage)
